<template lang="pug">
    .match.columns.is-multiline.is-gapless(:class="{ 'is-active': isActive }")
        .column.is-12.match-header(:class="[timeLevelClass]")
            .columns.is-gapless.is-mobile
                .column.is-one-fifth-tablet
                    a.match-link(:href="matchURL" target="_blank")
                        span.icon.is-medium
                            i.fas.fa-futbol.fa-lg
                    span.icon.is-small(v-if="match.hasSignal")
                        i.fas.fa-check-circle
                .column.columns.is-gapless
                    .column
                        .title.is-5.is-unselectable {{ match.league }}
                    .column.is-one-quarter-tablet
                        .match-time.is-flex.is-unselectable
                            .title.is-4(@click="$emit('view')") {{ match.time }}
        .column.is-12.match-content.columns.is-multiline
            .column.is-two-fifths-widescreen.is-full-tablet.match-team(:class="`team-level-${propByCategory(match.home.statistic.level)}`")
                .title.is-4
                    span {{ match.home.team ? match.home.team.name : "Home team" }}
                    span.penalty-card.yellow(v-if="match.home.statistic.yellowCards") {{ match.home.statistic.yellowCards }}
                    span.penalty-card.red(v-if="match.home.statistic.redCards") {{ match.home.statistic.redCards }}
                .subtitle.is-5 {{ match.home.winCoef }}
                .match-sm
                    .columns.is-gapless.is-mobile
                        .column(v-if="match.home.statistic.scored && match.home.statistic.scored.length")
                            .subtitle.is-6 Scored
                            .level.is-mobile(v-for="scored in match.home.statistic.scored")
                                .level-left
                                    .level-item {{ scored.rate }}%
                                .level-right
                                    .level-item(v-html="sm(scored)")
                        .column(v-if="match.home.statistic.missed && match.home.statistic.missed.length")
                            .subtitle.is-6 Missed
                            .level.is-mobile(v-for="missed in match.home.statistic.missed")
                                .level-left
                                    .level-item {{ missed.rate }}%
                                .level-right
                                    .level-item(v-html="sm(missed)")
                        .column.score-wrapper
                            .match-times.is-hidden-touch
                                .time(v-for="time in match.home.statistic.goalTime") {{ time }}
                            .match-score.has-text-right.is-unselectable(
                                :class="{'is-active': match.home.activeGoal}") {{ match.home.statistic.score }}
            .column.is-full-tablet.is-one-fifth-widescreen
                .statistic-toggle.is-hidden-widescreen(@click="openStatistic=!openStatistic")
                    .title.is-6 Tech Statistic
                    a.is-toggle
                        span.icon(v-show="!openStatistic")
                            i.fas.fa-chevron-right
                        span.icon(v-show="openStatistic")
                            i.fas.fa-chevron-down
                table.table.is-narrow.is-fullwidth.is-hoverable.match-statistic(:class="{ 'is-active': openStatistic }")
                    tbody
                        tr(v-for="{ key, title } in statistic")
                            td.has-text-centered.is-size-7(v-html="objStat(key, key === 'xg' ? xGModel.home : match.home.statistic[key])")
                            td.has-text-centered.is-size-7.has-text-weight-bold {{ title }}
                            td.has-text-centered.is-size-7(v-html="objStat(key, key === 'xg' ? xGModel.away : match.away.statistic[key])")
                        tr
                            td.has-text-centered.is-size-7
                                span {{ match.over }}
                            td.has-text-centered.is-size-7
                                span.has-text-weight-bold Total:
                                span {{ match.total }}
                            td.has-text-centered.is-size-7
                                span {{ match.under }}
                        tr.is-hidden-desktop
                            td.has-text-centered.is-size-7
                                .time(v-for="time in match.home.statistic.goalTime") {{ time }}
                            td.has-text-centered.is-size-7.has-text-weight-bold Goal time
                            td.has-text-centered.is-size-7
                                .time(v-for="time in match.away.statistic.goalTime") {{ time }}
            .column.is-two-fifths-widescreen.is-full-tablet.has-text-right.match-team(:class="`team-level-${propByCategory(match.away.statistic.level)}`")
                .title.is-4
                    span.penalty-card.red(v-if="match.away.statistic.redCards") {{ match.away.statistic.redCards }}
                    span.penalty-card.yellow(v-if="match.away.statistic.yellowCards") {{ match.away.statistic.yellowCards }}
                    span {{ match.away.team ? match.away.team.name : "Away team" }}
                .subtitle.is-5 {{ match.away.winCoef }}
                .match-sm
                    .columns.is-gapless.is-mobile
                        .column.score-wrapper
                            .match-score.has-text-left.is-unselectable(
                                :class="{'is-active': match.away.activeGoal}") {{ match.away.statistic.score }}
                            .match-times.is-hidden-touch
                                .time(v-for="time in match.away.statistic.goalTime") {{ time }}
                        .column(v-if="match.away.statistic.missed && match.away.statistic.missed.length")
                            .subtitle.is-6 Missed
                            .level.is-mobile(v-for="missed in match.away.statistic.missed")
                                .level-left
                                    .level-item {{ missed.rate }}%
                                .level-right
                                    .level-item(v-html="sm(missed)")
                        .column(v-if="match.away.statistic.scored && match.away.statistic.scored.length")
                            .subtitle.is-6 Scored
                            .level.is-mobile(v-for="scored in match.away.statistic.scored")
                                .level-left
                                    .level-item {{ scored.rate }}%
                                .level-right
                                    .level-item(v-html="sm(scored)")
</template>

<script>
import _ from "lodash";

const xGMap = {
  dAtk: 0.02,
  sOn: 0.2,
  sOff: 0.1
};

export default {
  name: "Match",
  props: {
    match: Object,
    source: Object,
    active: Number
  },
  data: () => ({
    openStatistic: false,
    statistic: [
      {
        title: "Goal",
        key: "goal"
      },
      {
        title: "Loss",
        key: "loss"
      },
      {
        title: "xG model",
        key: "xg"
      },
      {
        title: "Dangerous Attack",
        key: "dAtk"
      },
      {
        title: "Shots",
        key: "shots"
      },
      {
        title: "Shots On Goal",
        key: "sOn"
      },
      {
        title: "Off Target",
        key: "sOff"
      },
      {
        title: "Corner Kicks",
        key: "cornerKicks"
      },
      {
        title: "Corner Kicks AVG",
        key: "corner"
      }
    ]
  }),
  computed: {
    isActive() {
      return this.match._id === this.active;
    },
    filterCategory() {
      return this.$store.getters.filterCategory(this.$route);
    },
    matchURL() {
      return `${this.source.url}/detail/${this.match._id}.html`;
    },
    timeLevelClass() {
      const timeLevel = this.propByCategory(this.match.timeLevel);
      if (!timeLevel) return "";
      switch (timeLevel) {
        case 1:
          return "has-background-primary";
        case 2:
          return "has-background-warning";
        case 3:
          return "has-background-danger";
        default:
          return "";
      }
    },
    xGMap() {
      const settings = [...this.$store.state.data.settings].find(
        ({ channel }) => channel === "live"
      );
      if (!settings) return xGMap;
      const profile = settings.settings.find(({ status }) => status);
      if (!profile) return xGMap;
      return profile.settings.xg || xGMap;
    },
    xGModel() {
      return ["home", "away"].reduce((acc, key) => {
        const result = Object.keys(this.xGMap).reduce(
          (total, param) =>
            total + (this.match[key].statistic[param] || 0) * this.xGMap[param],
          0
        );
        return { ...acc, [key]: result.toFixed(2) };
      }, {});
    }
  },
  methods: {
    propByCategory(prop) {
      if (!prop || !prop.hasOwnProperty(this.filterCategory)) return false;
      return prop[this.filterCategory];
    },
    objStat(type, value) {
      let res = value;

      if (_.isObject(value)) {
        let str = [];
        let joined = Object.keys(value).reduce(
          (str, key) => [...str, value[key] && value[key].toString()],
          []
        );

        let limit = Object.keys(value).reduce(
          (obj, key) => ({ ...obj, [key]: 0 }),
          {}
        );

        if (type === "goal" || type === "loss") {
          let s = this.$store.getters.getFilterSettingByKey(
            "live",
            "teamTotals"
          );

          if (!s) return joined;

          limit = {
            3: Number(s.values[0][0]),
            10: Number(s.values[0][1])
          };
        }

        Object.keys(res).forEach((key, i) => {
          let num = res[key];

          if (type === "goal" || type === "loss") {
            const $class = i === 0 ? "has-text-warning" : "has-text-danger";
            num =
              num >= limit[key]
                ? `<span class="has-text-weight-bold ${$class}">${num}</span>`
                : num;
          }

          str.push(num);
        });
        res = str.join("/");
      } else {
        if (["dAtk", "sOn", "sOff", "shots"].includes(type)) {
          const levelData = this.$store.getters.statLevelData;
          if (!levelData) return res;
          const statClass = { 1: "success", 2: "warning", 3: "danger" };
          const $class = Object.keys(levelData[type]).reduce((c, k) => {
            if (k > 3) return c;
            const limit = levelData[type][k];
            return res >= limit ? `has-text-${statClass[k]}` : c;
          }, "");
          return $class
            ? `<span class="has-text-weight-bold ${$class}">${res}</span>`
            : res;
        } else return value;
      }

      return res;
    },
    sm(obj) {
      let $class = "";
      if (obj.hasOwnProperty("level")) {
        switch (parseInt(obj.level)) {
          case 1:
            $class = "is-success";
            break;
          case 2:
            $class = "is-warning";
            break;
          case 3:
            $class = "is-danger";
            break;
        }
      } else if (obj.hasOwnProperty("time")) {
        const time = obj.time.split("~");
        switch (parseInt(time[0])) {
          case 1:
          case 16:
          case 31:
            $class = "is-success";
            break;
          case 61:
            $class = "is-warning";
            break;
          case 76:
            $class = "is-danger";
            break;
        }
      }
      return `<span class="tag ${$class}">${obj.time}</span>`;
    }
  }
};
</script>

<style lang="scss" scoped>
.match {
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  &.is-active {
    .match-header {
      .match-link {
        animation: rotate 3s infinite;
      }
    }
  }

  .match-header {
    color: #000;
    background: #d7d7d7;
    transition: all 0.3s linear;

    & > .columns {
      & > .column {
        &:first-child {
          display: flex;
          align-items: center;
          padding-left: 0.3rem !important;

          @media screen and (max-width: $tablet) {
            flex: 0;
          }
        }

        &:last-child {
          align-items: center;
          @media screen and (max-width: $tablet) {
            flex: 1;

            .column {
              &:first-child {
                justify-content: flex-end !important;

                .title {
                  padding: 0 1rem;
                  font-size: 0.9rem;
                  line-height: 1.5rem !important;
                  font-weight: normal;
                }
              }

              &:last-child {
                .match-time {
                  .title {
                    font-size: 1.2rem;
                    padding-bottom: 0.2rem;
                    font-weight: bold;
                  }
                }
              }
            }
          }

          .column {
            display: flex;
            &:first-child {
              justify-content: center;

              .title {
                line-height: 3rem;
              }
            }

            &:last-child {
              justify-content: flex-end;
              position: relative;

              .match-time {
                cursor: pointer;
                padding: 0 0.7rem;
                .title {
                  opacity: 0.8;

                  &::after {
                    content: "'";
                    animation: blink 1s infinite;
                  }
                }
              }
            }
          }
        }
      }
    }

    .match-link,
    .title {
      color: #000;
    }

    .match-link {
      display: inline-block;
      padding: 0.3rem;
      border-radius: 50%;
      background-color: transparent;
      transition: all 0.2s linear;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .match-content {
    & > .column {
      position: relative;
      overflow: hidden;

      .time {
        &::after {
          content: "'";
        }
      }

      &.match-team {
        @media screen and (max-width: $widescreen - 1) {
          min-height: 10rem;

          .title {
            font-size: 1rem;
            font-weight: normal;
          }

          .subtitle {
            font-size: 1rem;
            font-weight: bold;
          }

          &:last-child {
            &.team-level-1 {
              background: linear-gradient(
                180deg,
                #00bb8a 17.71%,
                rgba(196, 196, 196, 0) 100%
              );
            }
            &.team-level-2 {
              background: linear-gradient(
                180deg,
                #ffdd57 17.71%,
                rgba(196, 196, 196, 0) 100%
              );

              .title,
              .subtitle {
                color: #000;
              }

              .columns {
                align-items: flex-end;

                & > .column {
                  color: #fff;
                  .subtitle {
                    color: #fff;
                  }
                }
              }
            }
            &.team-level-3 {
              background: linear-gradient(
                180deg,
                #d33254 17.71%,
                rgba(196, 196, 196, 0) 100%
              );
            }
          }
        }

        &.team-level-1 {
          background: linear-gradient(
            180deg,
            rgba(196, 196, 196, 0) 17.71%,
            #00bb8a 100%
          );
        }
        &.team-level-2 {
          background: linear-gradient(
            180deg,
            rgba(196, 196, 196, 0) 17.71%,
            #ffdd57 100%
          );

          .match-sm {
            color: #000;
          }
        }
        &.team-level-3 {
          background: linear-gradient(
            180deg,
            rgba(196, 196, 196, 0) 17.71%,
            #d33254 100%
          );
        }

        & > .title {
          display: flex;
          align-items: center;
        }

        .penalty-card {
          font-size: 1rem;
          border-radius: 3px;
          height: 1.3rem;
          width: 1.1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $defaultColor;

          &.yellow {
            background-color: yellow;
            color: $cardFontColor;
          }
          &.red {
            background-color: red;
          }
        }

        &:first-child {
          .penalty-card {
            margin-left: 0.3rem;
          }
        }

        &:last-child {
          .penalty-card {
            margin-right: 0.3rem;
          }

          & > .title {
            justify-content: flex-end;
          }
        }
      }

      .statistic-toggle {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          margin-bottom: 0;
        }

        .is-toggle {
          color: #fff;
        }
      }

      .match-statistic {
        display: none;
        background-color: transparent;
        color: $defaultColor;
        cursor: default;

        &.is-active {
          display: table;
          margin-top: 0.5rem;
        }

        @media screen and (min-width: $widescreen) {
          display: table !important;
        }

        tr {
          td {
            border: none;

            &:nth-child(2) {
              span + span {
                margin-left: 0.3rem;
              }
            }
          }

          &:hover {
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
      }

      .match-score {
        font-size: 10rem;
        color: #3a4750;
        line-height: 8rem;
        font-weight: bold;
        font-style: italic;

        &.is-active {
          text-shadow: 4px -3px #ff3860, -5px 6px #ff3860, -3px -2px #ff3860,
            0 3px #ff3860, 3px 0 #ff3860, 0 -3px #ff3860;
        }
      }

      .match-sm {
        position: absolute;
        bottom: 0;
        width: calc(100% - 1.5rem);
        font-size: 0.9rem;

        .columns {
          align-items: flex-end;

          & > .column {
            flex: 0;
            margin-right: 2rem;
            margin-left: 0;
            padding-bottom: 0.7rem !important;
            z-index: 1;

            @media screen and (max-width: $tablet) {
              margin-right: 0.5rem !important;

              .subtitle {
                font-size: 0.9rem;
                font-weight: normal;
              }

              .level {
                font-size: 0.8rem;
                .level-left {
                  margin-right: 0.1rem !important;
                }
              }
            }

            .level {
              .level-left {
                margin-right: 1rem;
              }
            }

            &.score-wrapper {
              display: flex;
              align-items: flex-end;
              flex: 1;
              margin: 0;
              padding-bottom: 0 !important;

              @media screen and (max-width: $tablet) {
                margin-right: 0 !important;
                margin-left: 0 !important;
                position: absolute;
                bottom: -0.5rem;
                left: 0;
                right: auto;
                z-index: 0;
              }

              .match-times {
                flex: 1;
                display: inline-flex;
                flex-direction: column;
                flex-wrap: wrap;
                max-height: 8rem;
                padding: 0 0.3rem;
                align-content: flex-start;

                .time {
                  padding: 0 0.3rem;
                }
              }
            }
          }
        }

        .subtitle {
          margin-bottom: 0.5rem;
        }

        .level {
          &:not(:last-child) {
            margin-bottom: 0.1rem;
          }
        }
      }

      &:first-child {
        .match-sm {
          .columns {
            & > .column {
              &.score-wrapper {
                left: auto;
                right: 0;

                .match-times {
                  align-content: flex-end;
                }
              }
            }
          }
        }
      }

      &:last-child {
        .match-sm {
          .columns {
            justify-content: flex-end;
            & > .column {
              margin-left: 2rem;
              margin-right: 0;

              @media screen and (max-width: $tablet) {
                margin-left: 0.5rem !important;
                margin-right: 0 !important;

                &.score-wrapper {
                  margin: 0 !important;
                }
              }

              &.score-wrapper {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
}

@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
